import React from "react";
import PropTypes from "prop-types";

const LastHill = ({ className }) => (
  <svg className={className} viewBox="0 0 1440 1404" fill="none">
    <path
      d="M1147.93 134.16C1225.61 157.158 1302.02 168.43 1380.99 168.43C1421.02 143.356 1470.98 171.25 1513.23 171.25H1559.27C1572.86 171.25 1582.09 219.596 1592.08 234.708C1601.75 249.328 1611.71 256.68 1623.98 264.767L1592.08 755L1591.31 1294.9C1563.66 1298.5 1536.08 1300.82 1508.36 1302.32C1450.78 1305.45 1390.01 1329.3 1332.89 1342.03C1257.63 1358.8 1185.88 1382.11 1109.57 1382.11H1108.33C1060.64 1382.11 1015.36 1382.11 973.749 1339.06C939.528 1303.66 905.497 1269.85 866.645 1249.25C837.568 1233.84 806.337 1230.01 776.86 1215.11C728.654 1190.75 682.723 1156.08 634.435 1131.99C564.245 1096.96 498.189 1094.49 425.012 1094.88C302.485 1095.52 181.577 1112.15 60.4031 1141.63C22.2314 1150.92 -15.7782 1162.02 -54.2209 1167.98L-123.5 575.5L-65.0713 137.851C-65.0713 137.851 -41.3007 145.618 -25.5158 145.412C19.3081 144.829 63.794 133.479 108.602 131.858C147.248 130.459 187.016 128.646 225.444 136.206C262.524 143.5 299.02 155.887 336.318 161.269C393.829 169.567 451.68 163.471 508.753 152.318C552.144 143.838 595.42 130.252 636.903 107.562C662.002 93.8332 685.125 73.8998 709.615 57.9472C730.623 44.2625 750.511 24.9159 773.061 19.0738C789.979 14.6909 807.648 16.1771 824.73 16.5163C884.458 17.7025 938.252 46.8757 995.286 70.7345C1045.59 91.7774 1096.89 119.047 1147.93 134.16Z"
      fill="#F5F5F5"
      stroke="black"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
    />
  </svg>
);

LastHill.defaultProps = {
  className: ``
};

LastHill.propTypes = {
  className: PropTypes.string
};

export default LastHill;
